import { INVALIDATE_PLAN_COMPTABLE } from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';

const PLAN_COMPTABLE_API_ROUTE = process.env.REACT_APP_API_URL + '/v1/plancomptable_bydossier/';

const planComptableApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    // Mutation pour créer/uploader un plan comptable (fichier Excel)
    createPlanComptable: build.mutation({
      query(body) {
        return {
          url: PLAN_COMPTABLE_API_ROUTE,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [INVALIDATE_PLAN_COMPTABLE],
    }),

    // Mutation pour créer un nouveau compte comptable
    createCompteComptable: build.mutation({
      query(body) {
        return {
          url: `${PLAN_COMPTABLE_API_ROUTE}creer_compte/`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [INVALIDATE_PLAN_COMPTABLE],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreatePlanComptableMutation,
  useCreateCompteComptableMutation,
} = planComptableApi;
